import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 18 18",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M11.25 6.75h-4.5v4.5h4.5v-4.5ZM4.5 0H0v4.5h4.5V0ZM11.25 13.5h-4.5V18h4.5v-4.5ZM4.5 6.75H0v4.5h4.5v-4.5ZM4.5 13.5H0V18h4.5v-4.5ZM18 0h-4.5v4.5H18V0ZM11.25 0h-4.5v4.5h4.5V0ZM18 6.75h-4.5v4.5H18v-4.5ZM18 13.5h-4.5V18H18v-4.5Z" }, null, -1)
  ]))]))
}
export default { render };